import React from 'react';
import Lottie from 'lottie-react';
import lottieData from '../loading.json';
import '../css/home.css';

export default function LottieLoading() {
  return (
    <div className="dimbox">
      <Lottie animationData={lottieData} />
    </div>
  );
}
